export const t = {
    slideCountLabel: (index, total) => `${index} de ${total}`,
    slideArrowsLabel: {
        altPrev: 'Slide Anterior',
        altNext: 'Próximo Slide',
    },
};
//# sourceMappingURL=dictionary.js.map